import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from '@mui/material';
import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';

const ExternalLinkDialog = ({ 
  open, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  showExternalWarning = true,
  continueButtonText = 'Continue'
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          {message}
        </Typography>
        {showExternalWarning && (
          <Typography variant="body2" color="text.secondary">
            You will be redirected to the EZFacility website to complete this process.
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button 
          onClick={onConfirm} 
          variant="contained" 
          endIcon={showExternalWarning ? <OpenInNewIcon /> : null}
        >
          {continueButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExternalLinkDialog; 